"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Select_1 = require("@material-ui/core/Select");
const MenuItem_1 = require("@material-ui/core/MenuItem");
const InputLabel_1 = require("../InputLabel");
const Input_1 = require("../Input");
function Dropdown(_a) {
    var { id, label, placeholder, value, onChange, emptyValue, defaultValue, children } = _a, rest = __rest(_a, ["id", "label", "placeholder", "value", "onChange", "emptyValue", "defaultValue", "children"]);
    const [_value, _setValue] = React.useState(value || defaultValue || emptyValue);
    React.useEffect(() => {
        if (value) {
            _setValue(value);
        }
    }, [value]);
    return (React.createElement(React.Fragment, null,
        label && React.createElement(InputLabel_1.default, { label: label, id: id }),
        React.createElement(Select_1.default, Object.assign({ displayEmpty: true, disableUnderline: true, style: { minWidth: 120 }, input: React.createElement(Input_1.default, { id: id, placeholder: placeholder, value: _value, style: { color: "yellow" } }), value: _value, onChange: event => {
                if (!value) {
                    // If uncontrolled
                    _setValue(event.target.value);
                }
                onChange && onChange(event.target.value);
            } }, rest),
            emptyValue && (React.createElement(MenuItem_1.default, { disabled: true, value: emptyValue, style: { color: "gray" } }, placeholder)),
            children)));
}
exports.Dropdown = Dropdown;
Dropdown.Item = MenuItem_1.default;
//# sourceMappingURL=Dropdown.js.map